// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simplestream {
    width: 100%;
}
.simplestream-player {
    width: 100%;
    background: black;
}
.simplestream .vjs-texttrack-settings {
    display: none;
}
.simplestream .vjs-menu-item-text {
    text-transform: capitalize;
}
.simplestream .vjs-error-box {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    justify-content: center;
    background: black;
    color: white;
}
.simplestream .vjs-error-box img {
    width: 60px;
}
.simplestream .vjs-error-box img, 
.simplestream .vjs-error-box p {
    margin: 0px 0px 10px 0px;
}

.simplestream .video-js .vjs-control-bar {
    background-color: #000000 !important;
}
.video-js .vjs-big-play-button {
    background-color: #000000 !important;
}

.simplestream .simplestream-debug {
    color: greenyellow;
    background: black;
    font-family:courier, courier new, serif;
    height: 200px;
    overflow: scroll;
    padding: 10px;
    font-size: 10px;
}
.simplestream .simplestream-debug p {
    white-space: nowrap;
}

.video-js .vjs-overlay{
    color:#fff;
    font-size: 16px;
    position:absolute;
    text-align:center;
    background-color: #01b9da;
    border: 0.06666em solid #01b9da;
    border-radius: 0.3em;
    transition: all 0.4s;
    padding: 10px 20px;
}
.video-js .vjs-overlay:hover {
    cursor: pointer;
    border: 0.06666em solid #ffffff;
}
.video-js.vjs-paused .vjs-overlay{
    display: none;
}
.video-js .vjs-overlay-top-left{top:5px;left:5px}
.video-js .vjs-overlay-top{left:50%;margin-left:-16.5%;top:5px}
.video-js .vjs-overlay-top-right{right:5px;top:5px}
.video-js .vjs-overlay-right{right:5px;top:50%;transform:translateY(-50%)}
.video-js .vjs-overlay-bottom-right{bottom:45px;right:15px}
/*.video-js.vjs-user-inactive .vjs-overlay-bottom-right{bottom:15px;right:15px}*/
.video-js .vjs-overlay-bottom{bottom:3.5em;left:50%;margin-left:-16.5%}
.video-js .vjs-overlay-bottom-left{bottom:3.5em;left:5px}
.video-js .vjs-overlay-left{left:5px;top:50%;transform:translateY(-50%)}
.video-js .vjs-overlay-center{left:50%;margin-left:-16.5%;top:50%;transform:translateY(-50%)}`, "",{"version":3,"sources":["webpack://./src/simplestream/plugin.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,+BAA+B;IAC/B,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,+BAA+B;AACnC;AACA;IACI,aAAa;AACjB;AACA,gCAAgC,OAAO,CAAC,QAAQ;AAChD,2BAA2B,QAAQ,CAAC,kBAAkB,CAAC,OAAO;AAC9D,iCAAiC,SAAS,CAAC,OAAO;AAClD,6BAA6B,SAAS,CAAC,OAAO,CAAC,0BAA0B;AACzE,oCAAoC,WAAW,CAAC,UAAU;AAC1D,gFAAgF;AAChF,8BAA8B,YAAY,CAAC,QAAQ,CAAC,kBAAkB;AACtE,mCAAmC,YAAY,CAAC,QAAQ;AACxD,4BAA4B,QAAQ,CAAC,OAAO,CAAC,0BAA0B;AACvE,8BAA8B,QAAQ,CAAC,kBAAkB,CAAC,OAAO,CAAC,0BAA0B","sourcesContent":[".simplestream {\n    width: 100%;\n}\n.simplestream-player {\n    width: 100%;\n    background: black;\n}\n.simplestream .vjs-texttrack-settings {\n    display: none;\n}\n.simplestream .vjs-menu-item-text {\n    text-transform: capitalize;\n}\n.simplestream .vjs-error-box {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-items: center;\n    justify-content: center;\n    background: black;\n    color: white;\n}\n.simplestream .vjs-error-box img {\n    width: 60px;\n}\n.simplestream .vjs-error-box img, \n.simplestream .vjs-error-box p {\n    margin: 0px 0px 10px 0px;\n}\n\n.simplestream .video-js .vjs-control-bar {\n    background-color: #000000 !important;\n}\n.video-js .vjs-big-play-button {\n    background-color: #000000 !important;\n}\n\n.simplestream .simplestream-debug {\n    color: greenyellow;\n    background: black;\n    font-family:courier, courier new, serif;\n    height: 200px;\n    overflow: scroll;\n    padding: 10px;\n    font-size: 10px;\n}\n.simplestream .simplestream-debug p {\n    white-space: nowrap;\n}\n\n.video-js .vjs-overlay{\n    color:#fff;\n    font-size: 16px;\n    position:absolute;\n    text-align:center;\n    background-color: #01b9da;\n    border: 0.06666em solid #01b9da;\n    border-radius: 0.3em;\n    transition: all 0.4s;\n    padding: 10px 20px;\n}\n.video-js .vjs-overlay:hover {\n    cursor: pointer;\n    border: 0.06666em solid #ffffff;\n}\n.video-js.vjs-paused .vjs-overlay{\n    display: none;\n}\n.video-js .vjs-overlay-top-left{top:5px;left:5px}\n.video-js .vjs-overlay-top{left:50%;margin-left:-16.5%;top:5px}\n.video-js .vjs-overlay-top-right{right:5px;top:5px}\n.video-js .vjs-overlay-right{right:5px;top:50%;transform:translateY(-50%)}\n.video-js .vjs-overlay-bottom-right{bottom:45px;right:15px}\n/*.video-js.vjs-user-inactive .vjs-overlay-bottom-right{bottom:15px;right:15px}*/\n.video-js .vjs-overlay-bottom{bottom:3.5em;left:50%;margin-left:-16.5%}\n.video-js .vjs-overlay-bottom-left{bottom:3.5em;left:5px}\n.video-js .vjs-overlay-left{left:5px;top:50%;transform:translateY(-50%)}\n.video-js .vjs-overlay-center{left:50%;margin-left:-16.5%;top:50%;transform:translateY(-50%)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
